// Shopping-cart glyph, drawn inline.
//
// The brief called for lucide-react's ShoppingCart (replacing a bag), but
// lucide-react isn't a dependency of this app — same call as PencilIcon next
// door: for a 3-path icon the constraint against adding packages wins. Same
// silhouette and stroke weight as lucide's `shopping-cart`, and it inherits
// `currentColor` so a button only has to set its own colour.

interface Props {
  size?: number
}

export function CartIcon({ size = 15 }: Props) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
  )
}
